import { SVGProps } from 'react';

const BoxIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="76"
    height="98"
    viewBox="0 0 76 98"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.227539 26.4668L32.9182 46.0543V97.2448L0.227539 77.6573V26.4668Z"
      fill="#DDB96E"
    />
    <path
      d="M3.49658 33.5446L29.6491 49.2147V53.5004L3.49658 37.8304V33.5446Z"
      fill="#7C612E"
    />
    <path
      d="M3.49658 41.8779L29.6491 57.548V61.8337L3.49658 46.1636V41.8779Z"
      fill="#7C612E"
    />
    <path
      d="M3.49658 50.2113L29.6491 65.8813V70.1671L3.49658 54.497V50.2113Z"
      fill="#7C612E"
    />
    <path
      d="M0.223592 26.4691L32.9182 46.0538L75.7767 20.34L43.071 0.755276L0.223592 26.4691Z"
      fill="#F9E4B9"
    />
    <path
      d="M32.918 46.0543L75.7751 20.34V71.5305L32.918 97.2448V46.0543Z"
      fill="#7C612E"
    />
  </svg>
);

export default BoxIcon;
